import axios from "axios";

export const getDownloadLinkAPI = async (id, silence) => {
  let response = await axios({
    url: `/api/v2/drive/file/download`,
    method: "GET",
    params: {
      id
    }
  });
  if (silence) return response.data.dowload_link

  window.open(response.data.dowload_link);
};
